<template>
    <div>
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :disabled="itemIndex !== null"
                        :request-query-string-params="autocompleteQueryStringParams.material"
                        :repository="repositories.material"
                        :search-fields="autocompleteFields.material"
                        :validations="validations.material"
                        label="Material"
                        text-field="descricaoCompleta"
                        uppercase
                        v-model="model.material"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.quantidade"
                        label="Quantidade"
                        number
                        v-model="model.quantidade"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :disabled="!model.material || !model.material.possuiLote"
                        :validations="validations.lote"
                        label="Lote"
                        uppercase
                        v-model="model.lote"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-date-picker
                        :disabled="!model.material || !model.material.possuiLote"
                        :min-date="dataDocumento"
                        :validations="validations.validadeLote"
                        label="Validade do lote"
                        right
                        v-model="model.validadeLote"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.valorTotal"
                        label="Valor total"
                        ref="ValorTotal"
                        v-model="model.valorTotal"
                        v-money="money"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :disabled="!model.quantidade || formatSumMoney(model.valorTotal) === 0"
                        :validations="validations.valorUnitario"
                        label="Valor unitário"
                        ref="ValorUnitario"
                        v-model="model.valorUnitario"
                        v-money="money"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.numeroEmpenho"
                        label="Número do empenho"
                        number
                        v-model="model.numeroEmpenho"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.despesas"
                        label="Despesas"
                        ref="Despesas"
                        v-model.lazy="model.despesas"
                        v-money="money"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.numeroAutorizacaoFornecimento"
                        label="Número da autorização de fornecimento"
                        v-model="model.numeroAutorizacaoFornecimento"
                        v-mask="mask.numeroAutorizacaoFornecimento"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.codigoBarras"
                        label="Código de barras"
                        number
                        v-model="model.codigoBarras"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.fabricante"
                        :search-fields="autocompleteFields.fabricante"
                        :validations="validations.fabricante"
                        label="Fabricante"
                        uppercase
                        v-model="model.fabricante"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-button
                                @click="$refs.ModalFabricante.open()"
                                color="primary"
                                title="Cadastrar fabricante"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        {{ itemIndex === null ? 'Incluir' : 'Salvar' }}
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        {{ itemIndex === null ? 'Limpar' : 'Cancelar' }}
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ModalFabricante
            @save="model.fabricante = $event"
            ref="ModalFabricante"
        />
    </div>
</template>

<script>
// Components
import ModalFabricante from '@/components/cadastro/fabricante/Modal'

//Directives
import { VMoney } from 'v-money'

// Mixins.
import { repository, object, formats, mask } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import documentoTipo from '@/enums/almoxarifado/documentoTipo'

export default {
    components: { ModalFabricante },
    computed: {
        dataDocumento() {

            if (this.data.model.documento.data) {

                return moment(this.data.model.documento.data).format('DD/MM/YYYY')
            }

            return null
        },
        itensNaoEstornados() {

            return this.data.model.itens.filter(i => !i.estornado)
        },
        autocompleteFields() {

            return {
                material: [
                    { key: 'codigo_material', searchable: true },
                    { key: 'descricao', searchable: true },
                ],
                fabricante: [
                    { key: 'nome', searchable: true },
                ],
            }
        },
        autocompleteQueryStringParams() {

            return {
                material: { almoxarifado_check_controle_estoque: true }
            }
        },
        validations() {

            return {
                material: {
                    required: true,
                },
                quantidade: {
                    required: true,
                    min_value: 1,
                    max: 8,
                },
                lote: {
                    required: this.model.material && this.model.material.possuiLote,
                    max: 15,
                },
                validadeLote: {
                    required: this.model.material && this.model.material.possuiLote,
                },
                valorTotal: {
                    required: true,
                    min_value: this.isDocumentoDoacao ? 0.000000 : 0.000001,
                    max: 17,
                },
                valorUnitario: {
                    required: true,
                    min_value: this.isDocumentoDoacao ? 0.000000 : 0.000001,
                    max: 17,
                },
                numeroEmpenho: {
                    max: 20,
                },
                despesas: {
                    max: 17,
                },
                numeroAutorizacaoFornecimento: {
                    min_max_without_mask: 9,
                },
                fabricante: {
                    required: this.model.material && !!this.model.material.hasVinculoBnafar
                },
                codigoBarras: {
                    min: 13,
                    max: 13,
                },
            }
        },
        isDocumentoDoacao() {

            return this.data.model.documento.tipoId == this.enums.documentoTipo.DOACAO
        }
    },
    created() {

        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
            fabricante: this.getConectaSusRepository('cadastro.fabricante'),
        }
    },
    data: () => ({
        itemIndex: null,
        model: {
            id: null,
            material: null,
            quantidade: null,
            lote: null,
            validadeLote: null,
            valorTotal: '0,000000',
            valorUnitario: '0,000000',
            numeroEmpenho: null,
            despesas: '0,000000',
            numeroAutorizacaoFornecimento: null,
            fabricante: null,
            codigoBarras: null,
            estornoSalvo: false,
            estornado: false,
        },
        money: {
            decimal: ',',
            thousands: '.',
            suffix: '',
            precision: 6,
            masked: false
        },
        enums: { documentoTipo },
    }),
    directives: { money: VMoney },
    methods: {
        async loadToEdit({ index, item }) {

            this.itemIndex = index;

            this.model.id = item.id
            this.model.material = item.material

            await this.$nextTick()

            this.model.quantidade = item.quantidade

            await this.$nextTick()

            this.model.lote = item.lote

            this.model.validadeLote = item.validadeLote
                ? moment(item.validadeLote, 'DD/MM/YYYY').toDate()
                : null

            this.model.valorTotal = item.valorTotal
            this.$refs.ValorTotal.$el.getElementsByTagName('input')[0].value = item.valorTotal

            await this.$nextTick()

            this.model.valorUnitario = item.valorUnitario
            this.$refs.ValorUnitario.$el.getElementsByTagName('input')[0].value = item.valorUnitario

            this.model.numeroEmpenho = item.numeroEmpenho

            this.model.despesas = item.despesas
            this.$refs.Despesas.$el.getElementsByTagName('input')[0].value = item.despesas

            this.model.numeroAutorizacaoFornecimento = item.numeroAutorizacaoFornecimento
            this.model.fabricante = item.fabricante
            this.model.codigoBarras = item.codigoBarras
            this.model.estornoSalvo = item.estornoSalvo
            this.model.estornado = item.estornado
        },
        add() {

            if (this.itemIndex === null) {

                if (this.model.material.possuiLote) {

                    if (this.hasItemComLoteIncluso()) {

                        this.showValidationNotification('Material com o mesmo lote já incluso.')

                        return;
                    }
                }
                else if (this.hasItemSemLoteIncluso()) {

                    this.showValidationNotification('Material já incluso.')

                    return;
                }
            }

            const item = this.clone(this.model)

            if (item.validadeLote) {

                item.validadeLote = moment(item.validadeLote).format('DD/MM/YYYY')
            }

            if (this.itemIndex === null) {

                this.data.model.itens.push(item)
            }
            else {

                this.$set(this.data.model.itens, this.itemIndex, item)
            }

            this.resetForm()
        },
        hasItemSemLoteIncluso() {

            return !!this.itensNaoEstornados.find(i => i.material.id === this.model.material.id && i.lote == null)
        },
        hasItemComLoteIncluso() {

            return !!this.itensNaoEstornados.find(i => i.material.id === this.model.material.id
                && i.lote === this.model.lote)
        },
        resetForm() {

            this.itemIndex = null
            this.model.id = null
            this.model.material = null
            this.model.quantidade = null
            this.model.lote = null
            this.model.validadeLote = null

            this.model.valorTotal = '0,000000'
            this.$refs.ValorTotal.$el.getElementsByTagName('input')[0].value = '0,000000'

            this.model.numeroEmpenho = null;

            this.model.despesas = '0,000000'
            this.$refs.Despesas.$el.getElementsByTagName('input')[0].value = '0,000000'

            this.model.numeroAutorizacaoFornecimento = null
            this.model.fabricante = null
            this.model.codigoBarras = null
            this.model.estornoSalvo = false
            this.model.estornado = false

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        setValorUnitario() {

            let valorUnitario = 0.0

            const quantidade = parseInt(this.model.quantidade)
            const valorTotal = this.formatSumMoney(this.model.valorTotal)

            if (quantidade > 0 && valorTotal > 0) {

                valorUnitario = valorTotal / quantidade
            }

            valorUnitario = this.formatMoney(valorUnitario, 6)

            this.model.valorUnitario = valorUnitario
            this.$refs.ValorUnitario.$el.getElementsByTagName('input')[0].value = valorUnitario
        },
    },
    mixins: [ repository, object, formats, mask ],
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'model.material': function (material) {

            if (!material) {

                this.model.lote = null
                this.model.validadeLote = null
            }
        },
        'model.quantidade': function () {

            this.setValorUnitario()
        },
        'model.valorTotal': function () {

            this.setValorUnitario()
        },
    }
}
</script>